import { Helmet } from 'react-helmet';

interface PageSeoProps {
  /** Full <title> text, already localised by the caller. */
  title: string;
  /** Meta description, already localised. Omit to inherit the storefront default. */
  description?: string;
  /** Keep this route out of the index while still following its links. */
  noIndex?: boolean;
}

/**
 * Per-route <title> and meta description.
 *
 * Series3App renders one storefront-wide title for the whole SPA, so without an override every
 * route — the listing page, each PDP, /login, /gift — serves the identical tag. Search Console
 * showed the consequence: 24 indexed URLs sharing one title, with the listing page ranking in the
 * 30s-60s for category terms it should own. react-helmet applies the most recently mounted
 * instance, so rendering this inside a view wins over the root.
 */
export default function PageSeo({ title, description, noIndex }: PageSeoProps) {
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {noIndex ? <meta name="robots" content="noindex, follow" /> : null}
    </Helmet>
  );
}
